module.exports = __webpack_public_path__ + "img/img07.8720ec9b.png";